'use client';

/**
 * ToolTimeoutRecovered — the "retry worked" confirmation, deliberately a
 * SLIM inline strip rather than a full StandardCard: the actual tool result
 * renders separately through the existing tool-registry path
 * (lib/tool-registry.ts -> content/course-panel.tsx / rag-content.tsx), so
 * this component's only job is the one-line "it worked" beat directly
 * above it. Reuses V3_COLORS.liveGreen (the same green the rest of the
 * live-agent flow uses for a "good news" moment) rather than introducing a
 * new green.
 *
 * Copy note: this used to say "Reconnected — here's what I found", which
 * was factually wrong — nothing ever disconnected/reconnected here, the
 * lookup just succeeded on a later attempt (or on its own — see
 * useToolTimeoutFlow.ts's SUCCEEDED note). "Got it" describes what
 * actually happened without implying a connection event, at the exact
 * moment the user is deciding whether to trust the result underneath it.
 */
import { Check } from 'lucide-react';
import { V3_COLORS } from '@/lib/design-tokens';

export function ToolTimeoutRecovered() {
  return (
    <div
      className="mx-auto flex w-full max-w-[85%] items-center gap-[8px] px-[4px] text-[13.5px] font-semibold sm:max-w-[70%]"
      style={{ color: V3_COLORS.liveGreen }}
    >
      <Check aria-hidden="true" className="size-[15px]" strokeWidth={2.5} />
      Got it — here&apos;s what I found
    </div>
  );
}
